import React from 'react';
import './styles.scss';

import refiner from '../../components/v3/Companies/assets/refiner.svg'
import offices from './refiner-offices.jpg';

import Header from '../../components/v3/Header';
import Footer from '../../components/Footer';
import SEO from '../../components/seo';
import moritz from './assets/moritz.jpeg';

const Customers = () => (
  <div className="page">
    <SEO
      title="Meet our Customers — Hyperping"
      keywords={['uptime', 'monitoring', 'status page', 'uptime monitoring']}
      description="Take a look at how our customers use Hyperping to gain confidence, and be more transparent with their own customers."
      image="https://s3.eu-central-1.amazonaws.com/cdn.hyperping/og-user-stories.png"
    />
    <Header />
    
    <div className="customer-story-wrapper">
      <h1>Refiner uses Hyperping to collect real-world response times and uptime statistics for all their services and APIs.</h1>
      <div className="customer-story">
        <div className="customer-story-main">
          <span className="customer-picture-wrapper"><img className="customer-picture" src={moritz} />
          <i>Words by <a href="https://www.linkedin.com/in/moritzdausinger/" target="_blank">Moritz Dausinger</a>, CEO & founder of Refiner.</i></span>
          <br/>
          <p>Refiner is a customer feedback software for SaaS companies. Since our launch in 2019, Refiner has been on a high growth trajectory and after three years, we are serving hundreds of happy customers around the globe. Our typical customers are data-driven B2C & B2B SaaS companies looking to gather customer feedback at scale throughout the entire user’s journey.</p>
          <p>Refiner specializes in launching perfectly timed in-app survey widgets. To accomplish this, our backend servers process millions of requests each day with spikes of 60.000 requests per minute. Reliably processing incoming user data in a timely manner is prerequisite for our service to function correctly.</p>
          <p>Obviously, we were setting up a robust monitoring strategy right from the beginning. Our hosting platform AWS collects infrastructure and application performance metrics for our tech team.</p>
          <p>But this was not enough for us.</p>
          <p>We were looking to collect real-world response times and uptime statistics for all our services and APIs. Gathered from different locations around the world, telling us exactly how our customers and their users experience our services.</p>
          <p>This is when we started using Hyperping and we haven't looked elsewhere since.</p>
          <p>With Hyperping we have full visibility on <a href="/">response times and uptime metrics</a> from around the globe. Knowing that our servers serve requests in milliseconds no matter where a customer is located, gives us confidence and peace of mind.</p>
          <p>What we absolutely love about Hyperping is their <a href="/status-page">beautifully designed status page</a>. We made our Hyperping status page publicly available and it became a crucial part of our sales pitches. We are proud of our uptime and we love that we can share it with prospects and customers in such an easy way</p>
          <p>This year we want to take things one step further and start using the incident management system of Hyperping. Sending out emails and text messages to our customer base and informing them in real-time of service degradations is the logical next step for us.</p>
        </div>
        <div className="customer-story-details">
          <div className="customer-logo"><img src={refiner} /></div>

          <div className="customer-website">
            <span>Industry</span>
            <span>SaaS</span>
          </div>
          <div className="customer-website">
            <span>Website</span>
            <span><a href="https://refiner.io" title="Refiner.io: Customer feedback tool for SaaS" target="_blank">refiner.io</a></span>
          </div>
          <div className="customer-website">
            <span>Location</span>
            <span>Paris & remote</span>
          </div>
          
          <div className="customer-website">
            <span>Status page</span>
            <span><a href="https://status.refiner.io" target="_blank">status.refiner.io</a></span>
          </div>
          {/* <img src={offices} /> */}
        </div>
      </div>
    </div>


    <Footer darkMode={true} />
  </div>
);

export default Customers;
